import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { Grid, Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { Close as CloseIcon, WarningAmber } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

const CustomSnackbar = ({ open, message, onClose, type }) => {
  const snackbarStyles = {
    success: { backgroundColor: '#4caf50' },
    error: { backgroundColor: '#f44336' },
    info: { backgroundColor: '#2196f3' },
    warning: { backgroundColor: '#ff9800' },
  };

  const iconMap = {
    success: <CheckCircleIcon />,
    error: <ErrorIcon />,
    info: <InfoIcon />,
    warning: <WarningAmber />,
  };

  return (
    <Box m="5px" id="sbar">
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={open}       
    autoHideDuration={6000}
        onClose={onClose}
      >
        <SnackbarContent
          style={snackbarStyles[type]}
          message={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {iconMap[type]}
              <span id="client-snackbar" style={{ marginLeft: '8px' , }}>
                {message}
              </span>
            </div>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>
    </Box>

  );
};

export default CustomSnackbar;
